import xor from 'lodash/xor'
import { CardArtAssetName } from '../../types'

const getCardArtFromList = (
  cardArtList: CardArtAssetName[] = ['greenlineV0', 'silverlineV0', 'goldlineV0']
) => {
  let hasMultiple = true
  let combinedCardArt: CardArtAssetName = 'gold-silver-green'

  if (cardArtList.length === 1) {
    hasMultiple = false
    // eslint-disable-next-line prefer-destructuring
    combinedCardArt = cardArtList[0]
  } else if (xor(cardArtList, ['greenlineV0', 'silverlineV0']).length === 0) {
    combinedCardArt = 'silver-green'
  } else if (xor(cardArtList, ['greenlineV0', 'goldlineV0']).length === 0) {
    combinedCardArt = 'gold-green'
  } else if (xor(cardArtList, ['silverlineV0', 'goldlineV0']).length === 0) {
    combinedCardArt = 'silver-gold'
  }

  return { combinedCardArt, hasMultiple }
}

export default getCardArtFromList
